export default function(fields = {}) {
  return {
    awardLevel: {
      value: fields.newLevel
    }
  }
}
